export default __webpack_public_path__ + "static/media/Bracers of the Riftcaller.ec640f18.jpg";